<script setup lang="ts">
import { computed } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { DateFormField } from '@shared/common/form/domain/form/field/date.form-field';
import type { FormFieldDateComponent } from '@shared/common/form/application/component/date/form-field-date-component.types';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';

const model = defineModel<DateFormField>({ required: true });
const component = container.get<FormFieldDateComponent>(FormDependencyTypes.FormFieldDateComponent);

const dateValue = computed({
  get: () => model.value.value,
  set: (value: Date | null) => {
    model.value.value = value;
  },
});

const feedbackState = computed(() => (model.value.errorMessages?.length ? 'error' : undefined));
const feedbackText = computed(() => model.value.errorMessages?.[0]);
</script>

<template>
  <component
    :is="component"
    :id="model.id"
    v-model="dateValue"
    :data-testid="model.id"
    :title="model.label"
    :text="model.hint"
    :locale="model.locale ?? 'fr-FR'"
    :disabled="model.disabled ?? false"
    :placeholder="model.placeholder"
    :show-feedback="Boolean(model.errorMessages?.length)"
    :feedback-state="feedbackState"
    :feedback-text="feedbackText"
    :min-date="model.minDate"
    :max-date="model.maxDate"
    :show-time="model.showTime"
    :time-step-minutes="model.timeStepMinutes"
    :time-placeholder="model.timePlaceholder"
  />
</template>
